module.exports = __webpack_public_path__ + "static/merit-mile-home-page-a9a3966a327a657ff1daa763295c4886.mp4";